import React from 'react';
import { Box } from 'rebass';

const getVariantStyles = (color) => {
  const colorUppercase = color.charAt(0).toUpperCase() + color.slice(1);
  
  return color === 'neutral' ? ({
    solid: {
      textColor: color === 'white' ? "#0F0717" : `var(--textOnBackgroundNeutral)`,
      backgroundColor: `var(--backgroundNeutral)`,
      backgroundColorHover: `var(--backgroundNeutralHover)`,
      backgroundColorActive: `var(--backgroundNeutralActive)`,
      borderColor: `var(--backgroundNeutral)`,
    },
    outline: {
      textColor: `var(--textNeutralSubtle)`,
      backgroundColor: `transparent`,
      backgroundColorHover: `var(--backgroundHoverAlpha)`,
      backgroundColorActive: `var(--backgroundActiveAlpha)`,
      borderColor: `var(--borderNeutralMutedAlpha)`,
    },
    ghost: {
      textColor: `var(--textNeutralSubtle)`,
      backgroundColor: `transparent`,
      backgroundColorHover: `var(--backgroundHoverAlpha)`,
      backgroundColorActive: `var(--backgroundActiveAlpha)`,
      borderColor: `transparent`,
    },
  }) : ({
    solid: {
      textColor: color === 'white' ? "var(--textNeutralMuted)" : `var(--textOnBackground${colorUppercase})`,
      backgroundColor: color === 'white' ? "var(--background)" : `var(--background${colorUppercase})`,
      backgroundColorHover: color === 'white' ? "var(--backgroundHover)" : `var(--background${colorUppercase}Hover)`,
      backgroundColorActive: color === 'white' ? "var(--backgroundActive)" : `var(--background${colorUppercase}Active)`,
      borderColor: `var(--background${colorUppercase})`,
    },
    outline: {
      textColor: `var(--text${colorUppercase})`,
      backgroundColor: `transparent`,
      backgroundColorHover: `var(--backgroundHoverAlpha)`,
      backgroundColorActive: `var(--backgroundActiveAlpha)`,
      borderColor: `var(--borderNeutralMutedAlpha)`,
    },
    ghost: {
      textColor: `var(--text${color})`,
      backgroundColor: `transparent`,
      backgroundColorHover: `var(--backgroundHoverAlpha)`,
      backgroundColorActive: `var(--backgroundActiveAlpha)`,
      borderColor: `transparent`,
    },
  });
};

const Button = ({ color, variant, ...props }) => {
  const { textColor, backgroundColor, backgroundColorHover, backgroundColorActive, borderColor } = getVariantStyles(color)[variant];

  return (
    <Box
      as="button"
      className={`button focus ${color}`}
      css={`
        color: ${textColor};
        background: ${backgroundColor};
        border: 1px solid ${borderColor};
        padding: 10px 16px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        font-family: 'Inter', sans-serif;

        &:hover {
          background: ${backgroundColorHover};
        }

        &:active {
          background: ${backgroundColorActive};
        }

        &:focus:not(:focus-visible) {
          outline: none;
          box-shadow: none;
        }
      `}
      {...props}
    />
  )
}

Button.defaultProps = {
  color: 'neutral',
  variant: 'outline',
};

export default Button